/**
 * Plain-language stat label with the technical term kept secondary
 * (design/reshape/RESHAPE.md §3, AUDIT.md finding 6: "the technical term is
 * primary, there is no plain-language gloss at all"). Builds
 * `<span class="obs-stat-label">Plain <span class="obs-stat-label-tech">(technical)</span></span>`
 * — the value/tooltip/data this label sits beside is unchanged; only the
 * visible label text changes. `technical` is optional: a row whose label is
 * already plain language (e.g. "Model") renders with no secondary term.
 */
export function statLabel(plain: string, technical?: string): HTMLSpanElement {
  const label = document.createElement("span");
  label.className = "obs-stat-label";
  if (!technical) {
    label.textContent = plain;
    return label;
  }
  label.textContent = `${plain} `;
  const tech = document.createElement("span");
  tech.className = "obs-stat-label-tech";
  tech.textContent = `(${technical})`;
  label.appendChild(tech);
  return label;
}
